import { render } from "./ourServicesComponent.vue?vue&type=template&id=04965bb8&scoped=true"
import script from "./ourServicesComponent.vue?vue&type=script&lang=js"
export * from "./ourServicesComponent.vue?vue&type=script&lang=js"

import "./ourServicesComponent.vue?vue&type=style&index=0&id=04965bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04965bb8"]])

export default __exports__